import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../Services/auth.service';
import { MatchingService } from '../Services/matching.service';
import { CustomerInputService } from '../Services/customer-input.service';
import { ScService } from '../search-data/sc.service';
import { SearchService } from '../Services/search-condition.service';
import { FormService } from "../Services/form.service";
import * as constant from '../constant';
import { DomSanitizer } from '@angular/platform-browser';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.css']
})
export class SearchResultComponent implements OnInit {
  @ViewChild('downloadLink') downloadLink: ElementRef;

  logininfo: Logininfo = this.auth.loginID;
  sc = this.scService.sc;
  result: any;
  divisions: string[];
  users: any;
  sales_users: any;
  construction_users: any;
  gender: string[];
  Prefectures: string[];
  status: any = constant.status;
  status2: any = constant.status2;
  ranks: any = constant.ranks;
  ranks_ob: any = constant.ranks_ob;

  downloadUrl = null;
  downloadFile = '';

  csv_no_output = [
    'created_at',
    'created_user_id',
    'updated_at',
    'updated_user_id',
    'deleted_at',
    'address_no_contact',
    'tel_no_contact',
    'a1',
    'a1_introducer',
    'a1_other',
    'a2_3',
    'a2_3_introduced',
    'a2_3_memo',
    'first_contanct_calendar_id',
    'is_next_app',
    'visit_apply'
  ];

  constructor(
    private searchService: SearchService,
    private scService: ScService,
    private router: Router,
    public customerInputService: CustomerInputService,
    public matchingService: MatchingService,
    private formService: FormService,
    private el: ElementRef,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    public auth: AuthService
  ) { }

  ngOnInit() {
    //顧客検索
    this.sc = this.scService.sc;
    if (!Object.keys(this.sc.a1).length) {
      this.sc.a1 = "";
    }
    if (!Object.keys(this.sc.a3).length) {
      this.sc.a3 = "";
    }
    if (!Object.keys(this.sc.a8).length) {
      this.sc.a8 = "";
    }

    let list = this.searchService.getSearchData(this.scService.sc);
    list.subscribe(list => {
      this.result = list;
    });

    this.gender = this.formService.gender;
    this.Prefectures = this.formService.getPrefectures();
    //担当者表示用
    let list2 = this.customerInputService.customerBase(0);
    list2.subscribe(list2 => {
      this.divisions = list2['division'];
      this.users = list2['user'];
      this.sales_users = list['sales_users'];
      this.construction_users = list['construction_users'];
    });
  }

  //顧客詳細へ
  customerDetail(id) {
    this.scService.sc = this.sc;
    this.matchingService.br_flg = false;
    this.customerInputService.ip_flg = false;
    this.router.navigate(['/detail/' + id]);
  }

  //検索条件入力画面に戻る
  backCustomerSerch() {
    this.scService.sc = this.sc;
    this.router.navigate(['/search/']);
  }

  onClickDownload(result) {
    var res = "";
    result.forEach((val, i) => {
      if (i == 0) {
        Object.keys(val).forEach(function (key) {
          if (this.csv_no_output.indexOf(key) >= 0) return;
          var key_name = this.conversionKey(key);
          res += key_name + ",";
        }, this);
        res += "\n";
      }
      Object.keys(val).forEach(function (key) {
        if (this.csv_no_output.indexOf(key) >= 0) return;
        //if (i == 0) {
        //  var key_name = this.conversionKey(key);
        //  res += key_name + ",";
        //} else {
        //値変換
        if (val[key] == null) {
          res += ",";
        } else if (key == 'gender') {
          var g_val = val[key];
          this.formService.gender.forEach(function (gender) {
            if (val[key] == gender.value) {
              g_val = gender.label;
            }
          }, val);
          g_val = g_val == 0 ? '' : g_val;
          res += ('\"' + g_val + '\",');
        } else if (key == 'pref') {
          var p_val = val[key];
          var p_key = 0;
          this.formService.Prefectures.forEach(function (pref) {
            if (val[key] == p_key) {
              p_val = pref;
            }
            p_key++;
          }, val);
          p_val = p_val == 0 ? '' : p_val;
          res += ('\"' + p_val + '\",');
        } else if (key == 'status') {
          var s_val = val[key];
          if (val['division_code'] == 3) {
            constant.status2.forEach(function (status2) {
              if (val[key] == status2.value) {
                s_val = status2.label;
              }
            }, val);
          } else {
            constant.status.forEach(function (status) {
              if (val[key] == status.value) {
                s_val = status.label;
              }
            }, val);
          }
          s_val = s_val == 0 ? '' : s_val;
          res += ('\"' + s_val + '\",');
        } else if (key == 'rank') {
          var r_val = val[key];
          constant.ranks.forEach(function (ranks) {
            if (val[key] == ranks.value) {
              r_val = ranks.label;
            }
          }, val);
          r_val = r_val == 0 ? '' : r_val;
          res += ('\"' + r_val + '\",');
        } else if (key == 'rank_ob') {
          var rob_val = val[key];
          constant.ranks_ob.forEach(function (ranks_ob) {
            if (val[key] == ranks_ob.value) {
              rob_val = ranks_ob.label;
            }
          }, val);
          rob_val = rob_val == 0 ? '' : rob_val;
          res += ('\"' + rob_val + '\",');
        } else if (key == 'warning') {
          if (val[key] == 1) {
            res += "\"要注意\",";
          } else {
            res += ",";
          }
        } else if (key == 'loss') {
          if (val[key] == 1) {
            res += "\"失注\",";
          } else {
            res += ",";
          }
        } else if (key == 'address_no_contact' || key == 'tel_no_contact') {
          if (val[key]) {
            res += "\"連絡不要\",";
          } else {
            res += ",";
          }
        } else if (key == 'ground_prayer_none') {
          if (val[key] == '1') {
            res += "\"地鎮祭なし\",";
          } else {
            res += ",";
          }
        } else if (key == 'a1') {
          let joinStr = this.changeValue(val[key]);
          res += (joinStr + ",");
        } else {
          res += (this.changeValue(val[key]) + ",");
        }
        //}
      }, this);
      //res += "\r\n";
      res += "\n";
    }, this);

    const data = res;
    const contentType = 'plain/csv';
    const fileName = 'customerList.csv';
    var bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const blob = new Blob([bom, data], { type: contentType });

    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {

      const url = window.URL.createObjectURL(blob);
      this.downloadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.downloadFile = fileName;

      const component = this;
      setTimeout(function () {
        component.downloadLink.nativeElement.click();
      }, 100);
    }
  }

  changeValue(val, lists = undefined) {
    let rv = '';
    if (Array.isArray(val)) {
      let strVals = [];
      val.forEach((v) => {
        if (lists && (v in lists)) {
          strVals.push('\"' + lists[v] + '\"');
        } else {
          strVals.push('\"' + v + '\"');
        }
      });
      rv = strVals.join(' ');
    } else if (typeof val == "object") {
      rv = val;
      //} else if (typeof val == "string" && val.indexOf(',') > 0) {
    } else if (typeof val == "string") {
      //rv = val.replace(/,/g, ' ');
      rv = '\"' + val + '\"';
    } else {
      rv = val;
    }
    return rv;
  }

  conversionKey(key) {
    var key_name = "";
    //項目名変換
    if (key == 'customer_code') {
      key_name = "顧客コード";
    } else if (key == 'customer_no') {
      key_name = "顧客番号";
    } else if (key == 'contract_no') {
      key_name = "契約番号";
    } else if (key == 'customer_name') {
      key_name = "顧客氏名";
    } else if (key == 'joint_name1') {
      key_name = "連名１";
    } else if (key == 'joint_name2') {
      key_name = "連名２";
    } else if (key == 'kana_name') {
      key_name = "フリガナ";
    } else if (key == 'sales_contact_code') {
      key_name = "営業担当者コード";
    } else if (key == 'directer_code') {
      key_name = "現場担当者コード";
    } else if (key == 'uesr_code') {
      key_name = "ユーザコード";
    } else if (key == 'user_family_name') {
      key_name = "ユーザ名（姓）";
    } else if (key == 'user_name') {
      key_name = "ユーザ名（名）";
    } else if (key == 'division_code') {
      key_name = "事業部コード";
    } else if (key == 'division_name') {
      key_name = "事業部名称";
    } else if (key == 'division_short_name') {
      key_name = "事業部略称";
    } else if (key == 'birthday') {
      key_name = "生年月日";
    } else if (key == 'gender') {
      key_name = "性別";
    } else if (key == 'zip_code') {
      key_name = "郵便番号";
    } else if (key == 'pref') {
      key_name = "都道府県";
    } else if (key == 'city') {
      key_name = "市区町村名・番地";
    } else if (key == 'address') {
      key_name = "建物名";
    } else if (key == 'tel_number') {
      key_name = "電話番号";
    } else if (key == 'fax_number') {
      key_name = "FAX番号";
    } else if (key == 'mobile_number') {
      key_name = "携帯番号";
    } else if (key == 'mail_address') {
      key_name = "メールアドレス";
    } else if (key == 'address_no_contact') {
      key_name = "DM不要";
    } else if (key == 'tel_no_contact') {
      key_name = "電話連絡不要";
    } else if (key == 'contact_method') {
      key_name = "連絡方法";
    } else if (key == 'dm_sending') {
      key_name = "DM送付";
    } else if (key == 'family_name1') {
      key_name = "家族構成 名前1";
    } else if (key == 'family_relation1') {
      key_name = "家族構成 続柄1";
    } else if (key == 'family_bitrh1') {
      key_name = "家族構成 生年月日1";
    } else if (key == 'family_name2') {
      key_name = "家族構成 名前2";
    } else if (key == 'family_relation2') {
      key_name = "家族構成 続柄2";
    } else if (key == 'family_bitrh2') {
      key_name = "家族構成 生年月日2";
    } else if (key == 'family_name3') {
      key_name = "家族構成 名前3";
    } else if (key == 'family_relation3') {
      key_name = "家族構成 続柄3";
    } else if (key == 'family_bitrh3') {
      key_name = "家族構成 生年月日3";
    } else if (key == 'family_name4') {
      key_name = "家族構成 名前4";
    } else if (key == 'family_relation4') {
      key_name = "家族構成 続柄4";
    } else if (key == 'family_bitrh4') {
      key_name = "家族構成 生年月日4";
    } else if (key == 'family_name5') {
      key_name = "家族構成 名前5";
    } else if (key == 'family_relation5') {
      key_name = "家族構成 続柄5";
    } else if (key == 'family_bitrh5') {
      key_name = "家族構成 生年月日5";
    } else if (key == 'note') {
      key_name = "備考";
    } else if (key == 'status') {
      key_name = "ステータス";
    } else if (key == 'rank') {
      key_name = "ランク";
    } else if (key == 'rank_ob') {
      key_name = "ランク（OB）";
    } else if (key == 'introduction') {
      key_name = "紹介者数";
    } else if (key == 'warning') {
      key_name = "要注意";
    } else if (key == 'loss') {
      key_name = "失注";
    } else if (key == 'total_points') {
      key_name = "総ポイント数";
    } else if (key == 'land_points') {
      key_name = "土地ポイント数";
    } else if (key == 'land_owner') {
      key_name = "土地_土地所有";
    } else if (key == 'land_public_figure') {
      key_name = "土地_公図";
    } else if (key == 'land_transcript_land') {
      key_name = "土地_謄本（土地）";
    } else if (key == 'land_transcript_build') {
      key_name = "土地_謄本（建物）";
    } else if (key == 'land_survey_land') {
      key_name = "土地_測量図（土地）";
    } else if (key == 'land_survey_build') {
      key_name = "土地_測量図（建物）";
    } else if (key == 'land_buying') {
      key_name = "土地_買付申込書";
    } else if (key == 'land_value') {
      key_name = "土地_路線価図";
    } else if (key == 'land_lord_entering') {
      key_name = "土地_地主の立入許可";
    } else if (key == 'land_survey') {
      key_name = "土地_現地調査・役所調査";
    } else if (key == 'land_dismantling') {
      key_name = "土地_解体工事";
    } else if (key == 'land_dismantling_estimate') {
      key_name = "土地_解体工事見積依頼";
    } else if (key == 'land_preparation') {
      key_name = "土地_造成工事";
    } else if (key == 'land_preparation_estimate') {
      key_name = "土地_造成工事見積依頼";
    } else if (key == 'land_sewage') {
      key_name = "土地_上下水道取出";
    } else if (key == 'land_sewage_estimate') {
      key_name = "土地_上下水道見積依頼";
    } else if (key == 'land_lord_consent') {
      key_name = "土地_地主の承諾書";
    } else if (key == 'land_lease') {
      key_name = "土地_賃貸借契約";
    } else if (key == 'land_bound') {
      key_name = "土地_境界確定案内";
    } else if (key == 'land_note') {
      key_name = "土地備考";
    } else if (key == 'capital_points') {
      key_name = "資金ポイント数";
    } else if (key == 'capital_finance_type') {
      key_name = "資金_資金種別";
    } else if (key == 'capital_comp') {
      key_name = "資金_資金成立";
    } else if (key == 'capital_balance_plan') {
      key_name = "資金_事業収支計画";
    } else if (key == 'capital_identification') {
      key_name = "資金_本人確認書類（合算者含）";
    } else if (key == 'capital_privacy') {
      key_name = "資金_個人情報";
    } else if (key == 'capital_health_insurance') {
      key_name = "資金_健康保険証（合算者含）";
    } else if (key == 'capital_temporary_subsecription') {
      key_name = "資金_事前審査記入";
    } else if (key == 'capital_temporary_approval') {
      key_name = "資金_事前審査承認";
    } else if (key == 'capital_loan_consultant') {
      key_name = "資金_融資打診了解";
    } else if (key == 'capital_rough_finance_plan') {
      key_name = "資金_概算資金計画内容合意";
    } else if (key == 'capital_finance_plan') {
      key_name = "資金_資金計画書・見積内容合意";
    } else if (key == 'capital_note') {
      key_name = "資金備考";
    } else if (key == 'plan_points') {
      key_name = "プランポイント数";
    } else if (key == 'plan_hearing') {
      key_name = "プラン_ヒアリング";
    } else if (key == 'plan_suggestion') {
      key_name = "プラン_提案";
    } else if (key == 'plan_confirm') {
      key_name = "プラン_プラン確定";
    } else if (key == 'plan_law') {
      key_name = "プラン_法規確認（役所他）";
    } else if (key == 'plan_approval') {
      key_name = "プラン_承認図書受領";
    } else if (key == 'plan_solar') {
      key_name = "プラン_太陽光";
    } else if (key == 'plan_note') {
      key_name = "プラン備考";
    } else if (key == 'conflict_points') {
      key_name = "競合ポイント数";
    } else if (key == 'conflict') {
      key_name = "競合_競合";
    } else if (key == 'conflict_note') {
      key_name = "競合備考";
    } else if (key == 'affected_points') {
      key_name = "影響者ポイント数";
    } else if (key == 'affected') {
      key_name = "影響者_影響者";
    } else if (key == 'affected_note') {
      key_name = "影響者備考";
    } else if (key == 'time_points') {
      key_name = "時期ポイント数";
    } else if (key == 'time_timing') {
      key_name = "時期_時期";
    } else if (key == 'time_note') {
      key_name = "時期備考";
    } else if (key == 'visit_points') {
      key_name = "見学ポイント数";
    } else if (key == 'visit_construct') {
      key_name = "見学_構造現場";
    } else if (key == 'visit_model') {
      key_name = "見学_モデル";
    } else if (key == 'visit_ob') {
      key_name = "見学_OB宅";
    } else if (key == 'visit_note') {
      key_name = "見学備考";
    } else if (key == 'opertor_points') {
      key_name = "運営事業者ポイント数";
    } else if (key == 'opertor_open_confirm') {
      key_name = "運営事業者_出店確認";
    } else if (key == 'opertor_sublease') {
      key_name = "運営事業者_サブリース契約";
    } else if (key == 'opertor_note') {
      key_name = "運営事業者備考";
    } else if (key == 'app_poins') {
      key_name = "申込ポイント数";
    } else if (key == 'app_pay') {
      key_name = "申込_申込（入金済）";
    } else if (key == 'app_note') {
      key_name = "申込備考";
    } else if (key == 'lost_cause1') {
      key_name = "失注原因";
    } else if (key == 'lost_cause2') {
      key_name = "失注原因2";
    } else if (key == 'lost_status1') {
      key_name = "失注状態1";
    } else if (key == 'lost_status2') {
      key_name = "失注状態2";
    } else if (key == 'lost_date') {
      key_name = "失注日";
    } else if (key == 'contract_amount') {
      key_name = "請負金額";
    } else if (key == 'prospective_sales') {
      key_name = "見込売上";
    } else if (key == 'expected_gross_margin') {
      key_name = "見込粗利";
    } else if (key == 'finalized_sales') {
      key_name = "確定売上";
    } else if (key == 'decided_gross_profit') {
      key_name = "確定粗利";
    } else if (key == 'ap_date') {
      key_name = "面談日";
    } else if (key == 'first_contanct_datetime') {
      key_name = "初回面談日時";
    } else if (key == 'first_contanct_end_datetime') {
      key_name = "初回面談日時:終了時間";
    } else if (key == 'app_date') {
      key_name = "申込日";
    } else if (key == 'app_schedule_date') {
      key_name = "申込予定日";
    } else if (key == 'temporary_reception_date') {
      key_name = "事前審査受付日";
    } else if (key == 'temporary_reception_schedule_date') {
      key_name = "事前申込受付予定日";
    } else if (key == 'temporary_approval_date') {
      key_name = "事前承認日";
    } else if (key == 'temporary_approval_schedule_date') {
      key_name = "事前承認予定日";
    } else if (key == 'closing_schedule_date') {
      key_name = "クロージング予定日";
    } else if (key == 'contract_schedule_date') {
      key_name = "契約予定日";
    } else if (key == 'contract_date') {
      key_name = "契約実績日";
    } else if (key == 'contract_payment') {
      key_name = "契約時請負金額";
    } else if (key == 'contract_payment_add') {
      key_name = "追加契約時請負金額";
    } else if (key == 'location') {
      key_name = "建築地";
    } else if (key == 'land_area') {
      key_name = "土地面積";
    } else if (key == 'land_contract_target_date') {
      key_name = "土地契約予定日";
    } else if (key == 'land_contract_result_date') {
      key_name = "土地契約実績日";
    } else if (key == 'land_settlement_target_date') {
      key_name = "土地決済予定日";
    } else if (key == 'land_settlement_result_date') {
      key_name = "土地決済実績日";
    } else if (key == 'loan_temporary_app_target') {
      key_name = "融資事前申込予定日";
    } else if (key == 'loan_temporary_app_actual') {
      key_name = "融資事前申込実績日";
    } else if (key == 'finance_temporary_app_target') {
      key_name = "融資事前承認予定日";
    } else if (key == 'finance_temporary_app_actual') {
      key_name = "融資事前承認実績日";
    } else if (key == 'finance_application_target_date') {
      key_name = "融資本申込予定日";
    } else if (key == 'finance_application_actual_date') {
      key_name = "融資本申込実績日";
    } else if (key == 'finance_application') {
      key_name = "融資本申込先";
    } else if (key == 'flat') {
      key_name = "フラット";
    } else if (key == 'finance_app_target_date') {
      key_name = "融資本承認予定日";
    } else if (key == 'finance_app_actual_date') {
      key_name = "融資本承認実績日";
    } else if (key == 'bridge_loan_land_target') {
      key_name = "つなぎ融資金消（土地）予定";
    } else if (key == 'bridge_loan_land') {
      key_name = "つなぎ融資金消（土地）";
    } else if (key == 'bridge_loan_const_target') {
      key_name = "つなぎ融資金消（着工）予定";
    } else if (key == 'bridge_loan_const') {
      key_name = "つなぎ融資金消（着工）";
    } else if (key == 'bridge_loan_interim_target') {
      key_name = "つなぎ融資金消（中間）予定";
    } else if (key == 'bridge_loan_interim') {
      key_name = "つなぎ融資金消（中間）";
    } else if (key == 'money_consumpltion_agree_target') {
      key_name = "融資 金消契約予定日";
    } else if (key == 'money_consumpltion_agree') {
      key_name = "融資 金消契約日";
    } else if (key == 'ground_survey_request_date_target') {
      key_name = "地盤調査依頼予定日";
    } else if (key == 'ground_survey_request_date') {
      key_name = "地盤調査依頼";
    } else if (key == 'ground_survey_implement_date_target') {
      key_name = "地盤調査実施予定日";
    } else if (key == 'ground_survey_implement_date') {
      key_name = "地盤調査実施";
    } else if (key == 'dismantling_start_date_target') {
      key_name = "解体開始予定日";
    } else if (key == 'dismantling_end_date_target') {
      key_name = "解体完了予定日";
    } else if (key == 'dismantling_start_date') {
      key_name = "解体開始日";
    } else if (key == 'dismantling_end_date') {
      key_name = "解体完了日";
    } else if (key == 'garden_start_date_target') {
      key_name = "造成開始予定日";
    } else if (key == 'garden_end_date_target') {
      key_name = "造成完了予定日";
    } else if (key == 'garden_start_date') {
      key_name = "造成開始日";
    } else if (key == 'garden_end_date') {
      key_name = "造成完了日";
    } else if (key == 'ground_improvement_date_target') {
      key_name = "地盤改良工事予定日";
    } else if (key == 'ground_improvement_date') {
      key_name = "地盤改良工事日";
    } else if (key == 'improvement_flg') {
      key_name = "地盤改良工事";
    } else if (key == 'approval_book_get_date_target') {
      key_name = "承認図書取得予定日";
    } else if (key == 'approval_book_get_date') {
      key_name = "承認図書取得日";
    } else if (key == 'four_people_meeting_target') {
      key_name = "四者打合せ予定日";
    } else if (key == 'four_people_meeting') {
      key_name = "四者打合せ";
    } else if (key == 'solar') {
      key_name = "太陽光";
    } else if (key == 'final_decision_mark_target') {
      key_name = "最終決定印予定日";
    } else if (key == 'final_decision_mark') {
      key_name = "最終決定印";
    } else if (key == 'other_resuest_date1') {
      key_name = "他申請日①";
    } else if (key == 'other_resuest_date1_target') {
      key_name = "他申請予定日①";
    } else if (key == 'other_resuest_date1_memo') {
      key_name = "他申請①_メモ";
    } else if (key == 'other_resuest_date2') {
      key_name = "他申請日②";
    } else if (key == 'other_resuest_date2_target') {
      key_name = "他申請予定日②";
    } else if (key == 'other_resuest_date2_memo') {
      key_name = "他申請②_メモ";
    } else if (key == 'other_resuest_date3') {
      key_name = "他申請日③";
    } else if (key == 'other_resuest_date3_target') {
      key_name = "他申請予定日③";
    } else if (key == 'other_resuest_date3_memo') {
      key_name = "他申請③_メモ";
    } else if (key == 'other_resuest_date4') {
      key_name = "他申請日④";
    } else if (key == 'other_resuest_date4_target') {
      key_name = "他申請予定日④";
    } else if (key == 'other_resuest_date4_memo') {
      key_name = "他申請④_メモ";
    } else if (key == 'other_resuest_approval_date1') {
      key_name = "他申請許可日①";
    } else if (key == 'other_resuest_approval_date2') {
      key_name = "他申請許可日②";
    } else if (key == 'other_resuest_approval_date3') {
      key_name = "他申請許可日③";
    } else if (key == 'other_resuest_approval_date4') {
      key_name = "他申請許可日④";
    } else if (key == 'other_resuest_approval_date1_target') {
      key_name = "他申請許可予定日①";
    } else if (key == 'other_resuest_approval_date2_target') {
      key_name = "他申請許可予定日②";
    } else if (key == 'other_resuest_approval_date3_target') {
      key_name = "他申請許可予定日③";
    } else if (key == 'other_resuest_approval_date4_target') {
      key_name = "他申請許可予定日④";
    } else if (key == 'other_resuest_flg') {
      key_name = "他申請";
    } else if (key == 'confirm_resuest_date_target') {
      key_name = "確認申請予定日";
    } else if (key == 'confirm_resuest_date') {
      key_name = "確認申請日";
    } else if (key == 'confirm_resuest_approval_date_target') {
      key_name = "確認申請許可予定日";
    } else if (key == 'confirm_resuest_approval_date') {
      key_name = "確認申請許可日";
    } else if (key == 'construction_approval_request_target') {
      key_name = "着工承認申請予定日";
    } else if (key == 'construction_approval_date_target') {
      key_name = "着工承認予定日";
    } else if (key == 'construction_approval_request') {
      key_name = "着工承認申請日";
    } else if (key == 'construction_approval_date') {
      key_name = "着工承認日";
    } else if (key == 'construction_payment_plandate') {
      key_name = "着工金入金予定日";
    } else if (key == 'construction_payment_date') {
      key_name = "着工金入金日";
    } else if (key == 'construction_payment_plan') {
      key_name = "着工金入金予定金額";
    } else if (key == 'construction_payment') {
      key_name = "着工金入金金額";
    } else if (key == 'gl_layout_target') {
      key_name = "GL・配置確認予定日";
    } else if (key == 'gl_layout') {
      key_name = "GL・配置確認日";
    } else if (key == 'ground_prayer_target') {
      key_name = "地鎮祭予定日";
    } else if (key == 'ground_prayer') {
      key_name = "地鎮祭";
    } else if (key == 'ground_prayer_none') {
      key_name = "地鎮祭なし";
    } else if (key == 'base_construction_date_target') {
      key_name = "基礎着工予定日";
    } else if (key == 'base_construction_date') {
      key_name = "基礎着工日";
    } else if (key == 'midway_payment_plandate') {
      key_name = "中間金入金予定日";
    } else if (key == 'midway_payment_date') {
      key_name = "中間金入金日";
    } else if (key == 'midway_payment_plan') {
      key_name = "中間金入金予定額";
    } else if (key == 'midway_payment') {
      key_name = "中間金入金額";
    } else if (key == 'upper_build_date_target') {
      key_name = "上棟予定日";
    } else if (key == 'outlet_target') {
      key_name = "コンセント確認予定日";
    } else if (key == 'upper_build_date') {
      key_name = "上棟日";
    } else if (key == 'outlet') {
      key_name = "コンセント確認日";
    } else if (key == 'midway_check_date_target') {
      key_name = "中間検査予定日";
    } else if (key == 'midway_check_date') {
      key_name = "中間検査日";
    } else if (key == 'midway_check_flg') {
      key_name = "中間検査";
    } else if (key == 'framework_end_date_target') {
      key_name = "木完予定日";
    } else if (key == 'framework_end_date') {
      key_name = "木完日";
    } else if (key == 'company_inspection_date_target') {
      key_name = "社検予定日";
    } else if (key == 'company_inspection_date') {
      key_name = "社検日";
    } else if (key == 'complete_check_date_target') {
      key_name = "完了検査予定日";
    } else if (key == 'complete_check_date') {
      key_name = "完了検査日";
    } else if (key == 'completion_date_target') {
      key_name = "竣工予定日";
    } else if (key == 'completion_date') {
      key_name = "竣工日";
    } else if (key == 'final_payment_plandate') {
      key_name = "最終金入金予定日";
    } else if (key == 'final_payment_date') {
      key_name = "最終金入金日";
    } else if (key == 'final_payment_plan') {
      key_name = "最終金入金予定額";
    } else if (key == 'final_payment') {
      key_name = "最終金入金額";
    } else if (key == 'furniture_carryout_start_date_target') {
      key_name = "家具搬入予定日";
    } else if (key == 'furniture_carryout_end_date_target') {
      key_name = "家具搬出予定日";
    } else if (key == 'furniture_carryout_start_date') {
      key_name = "家具搬入日";
    } else if (key == 'furniture_carryout_end_date') {
      key_name = "家具搬出日";
    } else if (key == 'furniture_carryout_flg') {
      key_name = "家具搬出";
    } else if (key == 'complete_visit_start_date_target') {
      key_name = "完成見学会開始予定日";
    } else if (key == 'complete_visit_end_date_target') {
      key_name = "完成見学会最終予定日";
    } else if (key == 'complete_visit_start_date') {
      key_name = "完成見学会開始日";
    } else if (key == 'complete_visit_end_date') {
      key_name = "完成見学会最終日";
    } else if (key == 'complete_visit_flg') {
      key_name = "完成見学会";
    } else if (key == 'delivery_date_target') {
      key_name = "引渡予定日";
    } else if (key == 'delivery_target_flg') {
      key_name = "引渡予定日:お客様確認";
    } else if (key == 'delivery_date') {
      key_name = "引渡日";
    } else if (key == 'delivery_flg') {
      key_name = "引渡日:お客様確認";
    } else if (key == 'after_flg') {
      key_name = "アフター";
    } else if (key == 'after_date1_target') {
      key_name = "アフター1:予定日";
    } else if (key == 'after_date2_target') {
      key_name = "アフター2:予定日";
    } else if (key == 'after_date3_target') {
      key_name = "アフター3:予定日";
    } else if (key == 'after_date1') {
      key_name = "アフター1";
    } else if (key == 'after_date2') {
      key_name = "アフター2";
    } else if (key == 'after_date3') {
      key_name = "アフター3";
    } else if (key == 'question_datetime') {
      key_name = "アンケート日時";
    } else if (key == 'answer_location') {
      key_name = "アンケート回答場所";
    } else if (key == 'question_code') {
      key_name = "アンケートコード";
    } else if (key == 'question_no') {
      key_name = "アンケートNo";
    } else if (key == 'family_structure') {
      key_name = "家族構成";
    } else if (key == 'parent_num') {
      key_name = "両親";
    } else if (key == 'income') {
      key_name = "世帯収入";
    } else if (key == 'children') {
      key_name = "子どもについて";
    } else if (key == 'children_num') {
      key_name = "子供５人以上";
    } else if (key == 'car') {
      key_name = "車の保有台数";
    } else if (key == 'q_land') {
      key_name = "土地の有無";
    } else if (key == 'a1') {
      key_name = "アンケート内容1";
    } else if (key == 'a1_introducer') {
      key_name = "アンケート内容1_紹介者";
    } else if (key == 'a1_other') {
      key_name = "アンケート内容1_その他内容";
    } else if (key == 'a2_1') {
      key_name = "広告順_1";
    } else if (key == 'a2_2') {
      key_name = "広告順_2";
    } else if (key == 'a2_3') {
      key_name = "広告順_3";
    } else if (key == 'a2_1_introduced') {
      key_name = "紹介者_1";
    } else if (key == 'a2_2_introduced') {
      key_name = "紹介者_2";
    } else if (key == 'a2_3_introduced') {
      key_name = "紹介者_3";
    } else if (key == 'a2_1_memo') {
      key_name = "広告順_1_内容";
    } else if (key == 'a2_2_memo') {
      key_name = "広告順_2_内容";
    } else if (key == 'a2_3_memo') {
      key_name = "広告順_3_内容";
    } else if (key == 'a3') {
      key_name = "よく見る広告";
    } else if (key == 'a3_other') {
      key_name = "よく見る広告_その他内容";
    } else if (key == 'a4') {
      key_name = "予定時期";
    } else if(key == 'a4_memo'){
      key_name = "時期未定";
    } else if (key == 'a5') {
      key_name = "検討きっかけ";
    } else if (key == 'a5_other') {
      key_name = "検討きっかけ_その他内容";
    } else if (key == 'a6') {
      key_name = "予算";
    } else if (key == 'a7_1') {
      key_name = "競合1";
    } else if (key == 'a7_1_other') {
      key_name = "競合1_その他内容";
    } else if (key == 'a7_1_reason') {
      key_name = "競合1_理由";
    } else if (key == 'a7_2') {
      key_name = "競合2";
    } else if (key == 'a7_2_other') {
      key_name = "競合2_その他内容";
    } else if (key == 'a7_2_reason') {
      key_name = "競合2_理由";
    } else if (key == 'a7_3') {
      key_name = "競合3";
    } else if (key == 'a7_3_other') {
      key_name = "競合3_その他内容";
    } else if (key == 'a7_3_reason') {
      key_name = "競合3_理由";
    } else if (key == 'a7_4') {
      key_name = "競合4";
    } else if (key == 'a7_4_other') {
      key_name = "競合4_その他内容";
    } else if (key == 'a7_4_reason') {
      key_name = "競合4_理由";
    } else if (key == 'a7_5') {
      key_name = "競合5";
    } else if (key == 'a7_5_other') {
      key_name = "競合5_その他内容";
    } else if (key == 'a7_5_reason') {
      key_name = "競合5_理由";
    } else if (key == 'a8') {
      key_name = "用件";
    } else if (key == 'a8_other') {
      key_name = "用件_その他内容";
    } else if (key == 'title') {
      key_name = "目的";
    } else if (key == 'contents') {
      key_name = "内容";
    } else if (key == 'notice_id') {
      key_name = "注意コード";
    } else if (key == 'notice') {
      key_name = "注意内容";
    } else if (key == 'uc_status') {
      key_name = "状態";
    } else if (key == 'upfile') {
      key_name = "メモ画像";
    } else if (key == 'start_datetime') {
      key_name = "開始年月日";
    } else if (key == 'end_datetime') {
      key_name = "終了年月日";
    } else if (key == 'all_day_flag') {
      key_name = "終日フラグ";
    } else if (key == 'child_flag') {
      key_name = "子連れフラグ";
    } else if (key == 'accompany_user_code') {
      key_name = "同伴ユーザコード";
    } else if (key == 'holiday_flag') {
      key_name = "休暇フラグ";
    } else if (key == 'img_name') {
      key_name = "画像";
    } else if (key == 'img_memo') {
      key_name = "画像備考";
    } else if (key == 'created_at') {
      key_name = "登録日";
    } else if (key == 'created_user_id') {
      key_name = "登録者";
    } else if (key == 'updated_at') {
      key_name = "更新日";
    } else if (key == 'updated_user_id') {
      key_name = "更新者";
    } else if (key == 'deleted_at') {
      key_name = "削除日";
    } else {
      key_name = key;
    }

    return key_name;
  }

}
